export function normalizeString(input: string): string {
  return input
    .toLowerCase()
    .trim()
    .normalize("NFD") // rozdělí písmena a diakritiku (např. "ě" → "e" + háček)
    .replace(/[\u0300-\u036f]/g, ""); // smaže diakritické znaky
}
